/** @format */
import { ValidatablePlan } from 'common-typescript';
import { Attainment, EntityWithRule, Grade, GradeScale } from 'common-typescript/types';
import { CommonGradeAverageService } from './common-grade-average.service';

/** The grade of the grade scale that has the given local id */
export function getGrade(gradeId: number, gradeScale: GradeScale): Grade | undefined {
    return gradeScale.grades?.find(grade => grade.localId === gradeId);
}

/**
 * The credit-weighted grade average of a module, rounded to two decimals: from its attainment when it has one, otherwise from the
 * attainments under it in the plan. Missing when there is nothing to average.
 */
export function getGradeAverage(
    commonGradeAverageService: CommonGradeAverageService,
    module: EntityWithRule | null,
    moduleAttainment: Attainment | null,
    validatablePlan: ValidatablePlan,
    gradeScale: GradeScale,
): number | undefined {
    const method = 'COURSE_UNIT_AND_EMPTY_MODULE_ARITHMETIC_MEAN_WEIGHTED_BY_CREDITS';
    const allAttainments = Object.values(validatablePlan.attainmentsById ?? {});
    const attainmentIds = moduleAttainment
        ? [moduleAttainment.id]
        : commonGradeAverageService.getAttainmentIdsForModule(module, validatablePlan);
    const gradeAverage = commonGradeAverageService.calculateGradeAverage(attainmentIds, allAttainments, gradeScale, method)?.gradeAverage;
    return typeof gradeAverage === 'number' ? +gradeAverage.toFixed(2) : undefined;
}
